import { ListBookingItem } from "./Booking";

export class ClassChild {
    id: number;
    aisId: string;
    familyName: string;
    givenName: string;
    homeroom: Homeroom;
    booked: boolean;
}

class Homeroom {
    id: number;
    name: string;
    campusId: number;
    yearLevelId: number;
}

export class HolStudentFilter{
    name: string;
    parentEmail: string;
    status: string;
    limit:number;
    constructor() {
        this.name = '';
        this.status = 'active';
        this.limit = 5;
    }
}

export class ListStudent {
    count: number;
    data: ListStudentItem[];
    constructor() {
        this.count = 0
        this.data = []
    }
}

export class ListStudentItem {
    id: number;
    code: string;
    family_name: string;
    given_name: string;
    known_name: string;
    gender: string;
    date_of_birth: string;
    country: string;
    medical: medical[];
    status: string;
    homeroom_id: string;
    hol_bookings:ListBookingItem[];
    hol_parents:holParentItem[];
    constructor() {
    }


};

class medical{
    allergic: string;
    medication: string;
    under_doctor_care: string;
    limit_paticipation_athlentic: string;
    special_education_needs: string;
    special_education_support: string;
}

class holParentItem{
    id: number;
    hol_student_parents: any;
}



// WEBPACK FOOTER //
// ./src/holiday/models/ClassChild.ts